import { useState, useEffect } from 'react';
import { getEmailAttachments, type EmailAttachmentMeta } from '../utils/emailAttachments';

export interface EmailContext {
  subject: string;
  sender: string;
  senderEmail: string;
  body: string;
  receivedAt: string | null;
  attachments: EmailAttachmentMeta[];
}

export function useEmailContext() {
  const [email, setEmail] = useState<EmailContext | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const item = Office.context?.mailbox?.item;
    if (!item) {
      setLoading(false);
      return;
    }

    const subject = item.subject ?? '';
    const sender = item.from?.displayName ?? '';
    const senderEmail = item.from?.emailAddress ?? '';
    const receivedAt = item.dateTimeCreated?.toISOString() ?? null;
    const attachments = getEmailAttachments();

    // Body requires async callback
    item.body.getAsync(Office.CoercionType.Text, (result) => {
      setEmail({
        subject,
        sender,
        senderEmail,
        body: result.status === Office.AsyncResultStatus.Succeeded
          ? result.value.trim()
          : '',
        receivedAt,
        attachments,
      });
      setLoading(false);
    });
  }, []);

  return { email, loading };
}
